import React from 'react';

const Liens = (props) => {
        const lienObj = props.lienData.map((item) => {
            return (
                <li key={item.label}>
                    {item.label} <a href={item.link}>{item.linkText}</a>
                </li>
            )
        });
        return (
            <section className="liens">
                <h2 className="text-uppercase"><i className="fa fa-lg fa-external-link"></i> Liens</h2>
                <ul className="list-unstyled">{lienObj}</ul>
            </section>
        );
};

export default Liens;


// WEBPACK FOOTER //
// ./src/components/Liens.js